import { Component, OnInit } from '@angular/core';
import { DetailsService } from '../../service/details.service';

@Component({
  selector: 'app-premium-list',
  templateUrl: './premium-list.component.html',
  styleUrls: ['./premium-list.component.css']
})
export class PremiumListComponent implements OnInit {
  premiumLists: any;
  constructor(private details: DetailsService) { }

  ngOnInit() {
    this.details.getpremiumlist().then(list => {
      list.subscribe(listdata => {
        console.log(listdata);
        this.premiumLists = listdata;
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/premium/premium-list/premium-list.component.ts